module.exports = __webpack_public_path__ + "static/img/logo.6ee6bad.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo.png
// module id = s4eo
// module chunks = 24